import { FC } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { IConfirmationModal } from '../../utils/interfaces';
import AppLoader from '../AppLoader';
import { t } from 'i18next';
import { useAppDispatch } from '../../redux/hooks';
import { setIsShipmentUpdate } from '../../pages/BuildShipment/reducer';

export const ConfirmationModal: FC<IConfirmationModal> = ({
    showModal,
    confirmationModalHandler,
    confirmationMessage,
    confirmationTitle,
    confirmationOptionOnCancel,
    confirmationOptionOnYes,
    modalSize,
    isLoading = false,
    children,
    isDisabled = false,
}) => {
    const dispatch = useAppDispatch();

    return (
        <Modal
            size={modalSize}
            className="px-2 pt-5"
            show={showModal}
            onHide={() => confirmationModalHandler(false)}
            backdrop="static"
            keyboard={false}
            centered
            animation
        >
            {isLoading ? (
                <AppLoader loadingPosition="center" height="200px" />
            ) : (
                <>
                    <Modal.Header>
                        <Modal.Title>{confirmationTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {confirmationMessage && (
                            <label>{confirmationMessage}</label>
                        )}
                        {children}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="primary-button"
                            onClick={() => confirmationModalHandler(false)}
                        >
                            {confirmationOptionOnCancel
                                ? confirmationOptionOnCancel
                                : t('Common:cancel')}
                        </Button>
                        {confirmationOptionOnYes && (
                            <Button
                                className="secondary-button"
                                onClick={() => {
                                    dispatch(setIsShipmentUpdate(false));
                                    confirmationModalHandler(true);
                                }}
                                disabled={isDisabled}
                            >
                                {confirmationOptionOnYes}
                            </Button>
                        )}
                    </Modal.Footer>
                </>
            )}
        </Modal>
    );
};
